export default "__VITE_ASSET__HpZp4YFLb8PVmX83GxzrAg__"